import http from "../../services/http";
const path = "api";

const deleteSection = ({ onSuccess, onError, onEnd, id = "" }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.delete({
        url: path + `/section/${id}`,
        headers: { "x-auth-token": store.auth.token },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

export { deleteSection };
